// extracted by mini-css-extract-plugin
module.exports = {"video":"VideoSlider_video__2MPVq","skeleton":"VideoSlider_skeleton__1uHK8"};